module.exports = __webpack_public_path__ + "static/media/share_icon.1c37dd83.svg";